import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) {
    navigate("/admin/tableau", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bienvenue, Daniel.");
      navigate("/admin/tableau");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const inputClass = "w-full bg-[#121216] border border-[#D4AF37]/20 focus:border-[#D4AF37]/70 outline-none px-5 py-4 text-sm text-[#F8F9FA] placeholder:text-slate-600 transition-colors";

  return (
    <main data-testid="admin-login-page" className="pt-20 min-h-screen flex items-center justify-center px-6">
      <Reveal className="w-full max-w-md">
        <form onSubmit={submit} className="gold-card p-10" data-testid="admin-login-form">
          <div className="w-14 h-14 mx-auto border border-[#D4AF37]/40 rotate-45 flex items-center justify-center mb-8">
            <Lock size={20} className="text-[#D4AF37] -rotate-45" />
          </div>
          <h1 className="font-serif text-3xl text-center text-[#F8F9FA]">Espace Admin</h1>
          <p className="text-slate-500 text-xs text-center mt-2 uppercase tracking-[0.25em] font-mono">Daniel Dulude Photographe</p>
          <div className="space-y-5 mt-10">
            <input type="email" required data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)}
                   placeholder="Courriel" className={inputClass} />
            <input type="password" required data-testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)}
                   placeholder="Mot de passe" className={inputClass} />
            <button type="submit" data-testid="admin-login-submit-button" disabled={busy}
                    className="btn-gold w-full disabled:opacity-50">
              {busy ? "Connexion…" : "Se connecter"}
            </button>
          </div>
        </form>
      </Reveal>
    </main>
  );
}
